import { render } from "./MarqueeCuts.vue?vue&type=template&id=796e6530&scoped=true"
import script from "./MarqueeCuts.vue?vue&type=script&lang=js"
export * from "./MarqueeCuts.vue?vue&type=script&lang=js"

import "./MarqueeCuts.vue?vue&type=style&index=0&id=796e6530&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796e6530"]])

export default __exports__